import { NotificationCardProps } from "../types/NotificationModalProps";
import React from "react";
import { Button } from "primereact/button";
import "./NotificationCard.css";
import { NOTIFICATION_CARD_TYPES } from "./Constants";
import { ReactSVG } from "react-svg";

export const NotificationCard = (props: NotificationCardProps) => {
    const formatDateTime = (dateTime: Date) => {
        const date = dateTime.toLocaleDateString(undefined, {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit"
        });
        const time = dateTime.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit"
        });

        return (
            <div>
                <div
                    id="notification-card-date"
                    className="small-text font-semibold"
                >
                    {time}
                </div>
                <div id="notification-card-time" className="small-text mt-1">
                    {date}
                </div>
            </div>
        );
    };

    const notificationAction = () => {
        if (props.notification.action) {
            props.notification.action(props.notification);
        }
    };

    const fallbackIcon = () => {
        return (
            <i
                className="pi pi-info-circle"
                style={{ width: "24px", height: "24px" }}
            />
        );
    };

    return (
        <div
            id="notification-card"
            className="notification-card py-3"
            key={props.notification.id}
        >
            <div
                id="notification-card-content"
                data-cy="notification-card-content"
                className="grid"
            >
                <div className="col-1">
                    <ReactSVG
                        src={`${props.notification.iconSrc}`}
                        // eslint-disable-next-line
                        beforeInjection={(svg: any) => {
                            svg.setAttribute(
                                "style",
                                "width: 24px; height: 24px;"
                            );
                        }}
                        fallback={fallbackIcon}
                    />
                </div>
                <div className="col-8 pl-4 mt-1">
                    <div
                        id="notification-card-title"
                        className="notification-card-title"
                    >
                        {props.notification.title}
                    </div>
                    {props.notification.subText1 && (
                        <div
                            id="notification-card-subtext-1"
                            className="mt-2 uppercase"
                        >
                            {props.notification.subText1}
                        </div>
                    )}
                    {props.notification.subText2 && (
                        <div
                            id="notification-card-subtext-2"
                            className="small-text"
                        >
                            {props.notification.subText2}
                        </div>
                    )}
                </div>
                <div className="col-3 text-right flex justify-content-between flex-column align-items-end">
                    <div className="align-items-start">
                        {formatDateTime(props.notification.dateTime)}
                    </div>
                    {props.notification.type === NOTIFICATION_CARD_TYPES.CTA &&
                        props.notification.action && (
                            <div className="align-items-end">
                                <Button
                                    className="p-button p-button-sm p-button-secondary mt-1 view-notification-button"
                                    label={props.notification.buttonText}
                                    onClick={notificationAction}
                                />
                            </div>
                        )}
                </div>
            </div>
        </div>
    );
};
